<template>
    <div>
        <b-card no-body>
            <b-card-header class="border-0 pt-3 px-3 pb-0">
                <b-row align-v="center">
                    <b-col cols="10" class="d-flex align-items-center">
                        <h3 class="mb">I am looking for core product:</h3>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="pb-3">
                <b-row>
                    <b-col cols="12">
                        <el-radio-group v-model="looking_for_items">
                            <b-row>
                                <b-col cols="12">
                                    <el-radio label="property">Property</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="mortgage">Mortgage</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="personal_loan">Personal Loan</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="insurance">Insurance</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="refinance">Refinance</el-radio>
                                </b-col>
                                <b-col cols="12">
                                    <el-radio label="other">Other Cases</el-radio>
                                </b-col>
                            </b-row>
                        </el-radio-group>
                    </b-col>
                </b-row>
                <div class="text-right mt-2">
                    <el-button class="bg-primary py-2 px-3 text-white" @click="save" :loading="is_loading_save">Save</el-button>
                </div>
            </b-container>
        </b-card>
    </div>
</template>
<script>
    import { Checkbox, CheckboxGroup, RadioGroup, Radio,  Button } from 'element-ui'
    import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'

    export default {
        props: ['lead'],
        components: {
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        data() {
            return {
                looking_for_items:'',
                is_loading_save: false
            }
        },
        watch:{
            lead:{
                handler(newVal){
                    if(newVal.looking_for && newVal.looking_for.length > 0){
                        this.looking_for_items = newVal.looking_for[0]
                    }
                },
                immediate: true
            }
        },
        methods: {
            save(){
								let llf_content = [];
								llf_content[0] = this.looking_for_items;
								
                let data = {
                    "llf_content": llf_content   
                }

                this.is_loading_save = true
                axios.post(services.lead + 'lead/'+this.lead.lead_id+'/looking_for', data, {headers: getHeader()})
                    .then(res=>{
                        this.is_loading_save = false
                        this.notifySuccess('<b>Lead Looking For</b> - Successfully Updated.')
                    })
                    .catch(e =>{
                        this.is_loading_save = false
                        this.errorFunction(e)
                    })                    
            }
        }
    }
</script>